import React from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Icon, Modal, notification, Spin } from 'antd';
import { Redirect } from 'react-router';
import { Titlebar } from '../../../components';
import LayoutContent from '../../../layouts/app/layoutContent';
import LayoutContentWrapper from '../../../layouts/app/layoutWrapper';
import TeamsForm from '../form';

const { confirm } = Modal;

class TeamsEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      cancelUrl: this.props.location.state && this.props.location.state.redirect
        ? this.props.location.state.redirect
        : `/${this.props.currentPractice}/teams`,
      loading: false,
      redirectTo: null,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDeleteConfirm = this.handleDeleteConfirm.bind(this);
    this.removeTeam = this.removeTeam.bind(this);
  }

  handleSubmit(values) {
    this.setState({
      loading: true,
    });

    const variables = {
      ...values,
      id: this.props.data.getTeam.id,
      practiceId: this.props.currentPractice,
    };

    this.props.editTeam({ variables })
      .then(({ data }) => {
        if (data.editTeam.ok && !data.editTeam.errors) {
          this.handleSuccess(`${data.editTeam.team.name} has been successfully updated.`);
          return;
        }

        this.handleError(data.editTeam.errors);
      }).catch((error) => {
        console.log(error);
      });
  }

  handleDeleteConfirm() {
    confirm({
      title: 'Delete Team',
      content: `Are you sure you want to permanently delete ${this.props.data.getTeam.name}? This action cannot be undone.`,
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'Cancel',
      icon: 'close-circle',
      onOk: this.removeTeam,
      width: '680px',
    });
  }

  removeTeam() {
    this.props.deleteTeam({ variables: { id: this.props.data.getTeam.id, practiceId: this.props.currentPractice } })
      .then(({ data }) => {
        if (data.deleteTeam.ok && !data.deleteTeam.errors) {
          this.handleSuccess(`${this.props.data.getTeam.name} has been successfully deleted.`, 'deleted');
          return;
        }

        this.handleError(data.deleteTeam.errors);
      }).catch((error) => {
        console.log(error);
      });
  }

  handleSuccess(description, action) {
    notification.success({
      message: action === 'deleted' ? 'Team Deleted' : 'Team Updated',
      description,
    });

    this.setState({ redirectTo: `/${this.props.currentPractice}/teams` });
  }

  handleError(errors) {
    this.setState({ loading: false });

    errors.forEach((err) => {
      notification.error({
        message: 'Error',
        description: err.message,
      });
    });
  }

  render() {
    const { data: { loading, error, getTeam } } = this.props;

    if (loading) {
      return (
        <div>
          <Titlebar
            currentPractice={this.props.currentPractice}
            displayText="Edit Team"
          />
          <div className="loading-wrapper">
            <Spin indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />} />
          </div>
        </div>
      );
    }

    if (error) {
      return (
        <div>
          <Titlebar
            currentPractice={this.props.currentPractice}
            displayText="Edit Team"
          />
          <div className="loading-wrapper">
            <p>Whoopsie - team didn&apos;t load.</p>
          </div>
        </div>
      );
    }

    return (
      <div>
        <Titlebar
          currentPractice={this.props.currentPractice}
          displayText="Edit Team"
        />
        <LayoutContentWrapper>
          <LayoutContent>
            <TeamsForm
              cancelUrl={this.state.cancelUrl}
              team={getTeam}
              currentPractice={this.props.currentPractice}
              gblUserRole={this.props.gblUserRole}
              loading={this.state.loading}
              onDelete={this.handleDeleteConfirm}
              onSubmit={this.handleSubmit}
            />
            {this.state.redirectTo !== null && (
              <Redirect to={this.state.redirectTo} />
            )}
          </LayoutContent>
        </LayoutContentWrapper>
      </div>
    );
  }
}

const getTeamQuery = gql`
  query($id: ID!, $practiceId: String!) {
    getTeam(id: $id, practiceId: $practiceId) {
      id
      name
      advisors{
        id
      }
    }
  }
`;

const editTeamMutation = gql`
mutation editTeam($id: ID!, $name: String!, $practiceId: String!, $advisors: [ID]){
  editTeam(id: $id, name: $name, practiceId: $practiceId, advisors: $advisors ){
    ok
    team {
      id
      name
      practice{
        id
        practiceId
      }
      advisors{
        id
        email
        firstName
        lastName
      }
    }
  }
}
`;

const deleteTeamMutation = gql`
  mutation deleteTeam($id: ID!, $practiceId: String!) {
    deleteTeam(id: $id, practiceId: $practiceId) {
      ok
      errors {
        message
        path
      }
    }
  }
`;

export default compose(
  graphql(getTeamQuery, {
    options: props => ({
      fetchPolicy: 'network-only',
      variables: {
        id: Number(props.match.params.id),
        practiceId: props.currentPractice,
      },
    }),
  }),
  graphql(editTeamMutation, { name: 'editTeam' }),
  graphql(deleteTeamMutation, { name: 'deleteTeam' }),
)(TeamsEdit);
